export namespace Question {
    export enum Options {
        Confirm,
        Cancel,
    }
}
